module.exports = __webpack_public_path__ + "media/users/images/continue-with-email-icon-c1c190e4af3a869c3d69f11d195bd983.svg";